import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ef2a9ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "timeline" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "more-workouts"
}

import { ComputedRef, computed, ref, onBeforeMount, toRefs } from 'vue'

  import WorkoutCard from '@/components/Workout/WorkoutCard.vue'
  import NoWorkouts from '@/components/Workouts/NoWorkouts.vue'
  import { WORKOUTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { defaultOrder } from '@/utils/workouts'

  interface Props {
    sports: ISport[]
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sports: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
    sports: ISport[]
    user: IUserProfile
  }

  

  const store = useStore()

  const { sports, user } = toRefs(props)
  let page = ref(1)
  const per_page = 5
  const initWorkoutsCount =
    props.user.nb_workouts >= per_page ? per_page : props.user.nb_workouts
  onBeforeMount(() => loadWorkouts())
  const workouts: ComputedRef<IWorkout[]> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.TIMELINE_WORKOUTS]
  )
  const moreWorkoutsExist: ComputedRef<boolean> = computed(() =>
    workouts.value.length > 0
      ? workouts.value[workouts.value.length - 1].previous_workout !== null
      : false
  )

  function loadWorkouts() {
    store.dispatch(WORKOUTS_STORE.ACTIONS.GET_TIMELINE_WORKOUTS, {
      page: page.value,
      per_page,
      ...defaultOrder,
    })
  }
  function loadMoreWorkouts() {
    page.value += 1
    store.dispatch(WORKOUTS_STORE.ACTIONS.GET_MORE_TIMELINE_WORKOUTS, {
      page: page.value,
      per_page,
      ...defaultOrder,
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('workouts.LATEST_WORKOUTS')), 1),
    (_unref(user).nb_workouts > 0 && _unref(workouts).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(_unref(initWorkoutsCount)).keys()], (index) => {
            return (_openBlock(), _createBlock(WorkoutCard, {
              user: _unref(user),
              useImperialUnits: _unref(user).imperial_units,
              key: index
            }, null, 8, ["user", "useImperialUnits"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workouts), (workout) => {
            return (_openBlock(), _createBlock(WorkoutCard, {
              workout: workout,
              sport: 
          _unref(workouts).length > 0
            ? _unref(sports).filter((s) => s.id === workout.sport_id)[0]
            : null
        ,
              user: _unref(user),
              useImperialUnits: _unref(user).imperial_units,
              key: workout.id
            }, null, 8, ["workout", "sport", "user", "useImperialUnits"]))
          }), 128)),
          (_unref(workouts).length === 0)
            ? (_openBlock(), _createBlock(NoWorkouts, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(moreWorkoutsExist))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", { onClick: loadMoreWorkouts }, _toDisplayString(_ctx.$t('workouts.LOAD_MORE_WORKOUT')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})